export default __webpack_public_path__ + "static/media/confianca.c94873c7.svg";